import { render } from "./FilterConteudos.vue?vue&type=template&id=32fde361&scoped=true"
import script from "./FilterConteudos.vue?vue&type=script&lang=js"
export * from "./FilterConteudos.vue?vue&type=script&lang=js"

import "./FilterConteudos.vue?vue&type=style&index=0&id=32fde361&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fde361"]])

export default __exports__